/**
 * Compile-time feature toggles for the admin frontend.
 * Flip to true when a feature is ready to ship to users.
 */
export const FeatureFlags: {
  /** Multi-warehouse inventory (enable switch, Almacenes UI, warehouse pickers). */
  multiWarehouseEnabled: boolean;
} = {
  multiWarehouseEnabled: false,
};
